const filterChoices = (options?: Array<string> | Array<any>) => {
  return options?.filter((item, index) => {
    return options?.map((it: string) => it).indexOf(item) === index;
  });
};

export default filterChoices;
